import updateCartIconQuantity from "./update-cart-icon";
import overlay from './loader';
import $ from "jquery";
import debounce from "../utils/debouncer";

function updateFavoriteItemUrl(el) {
    return window.config.urls.favorite.update.replace(':cart:', cart(el).data('cart-id'));
}

function cartItem(el) {
    return $(el).parents('.is-cart-item[data-row-id]').first();
}

function cart(el) {
    return $(el).closest('[data-cart-id]');
}

function updateItem(cartItem, cart, el) {
    overlay(true);
    const api = updateFavoriteItemUrl(cartItem).replace(':rowId:', cartItem.data('row-id'));

    let data = $(cartItem).find("form").first().serialize();

    window.axios.patch(api, data)
        .then(({data: {template: template, success, cartId}}) => {
            // replace cartItem with api response
            $(cartItem).first()[0].outerHTML = $(template)[0].outerHTML;
        })
        .catch((e) => {
            const input = $(cart).find(`input[name="${cartItem.data('row-id')}[quantity]"]`);
            input.val(input.data('original'));
        })
        .finally(() => {
            overlay(false);
        });
}
function setValue(el, value, cart) {
    const item = cartItem(el.target);

    item.find('input.quantity').val(value);
    // Check if the value is 0 then remove the item from the cart.
    if (value === 0) {
        let deleteButton = $('.remove-favorite-item[data-row-id="' + item.data('rowId') + '"]').first().click();
        return;
    }

    debounce(item, () => {
        updateItem(item, cart, el)
    }, 700);
}

$(document).ready(function() {
    /**
     * Delete a favorite list
     */
    $('body').on('click', '.delete-profile-favorite-list', function (e) {
        e.preventDefault();
        let url = window.config.urls.favorites.delete;
        let id = $(this).attr('data-id');
        let token  = $("input[name='_token']").val();
        window.axios.delete(`${url}/${id}`).then(({data: result}) => {
            if (result.success) {
                window.location.href = window.config.urls.favorites.index;
            }
            if (!result.success) {
                console.log('Could not delete favorite list');
            }
        })
    });

    /**
     * Add a favorite list to cart
     */
    $('body').on('click', '.favorites-to-cart', function (e) {
        e.preventDefault();
        let id = $(this).attr('data-id');
        let url = window.config.urls.favorites.buy.replace(':id:', id);
        overlay(true);
        window.axios.post(url)
            .then(({data: result}) => {
                if (result.success) {
                    let modal = $('#add-to-cart-modal');

                    if (result.successText) {
                        $('#add-to-cart-success-content').text(result.successText);
                        $('#add-to-cart-success-container').show();
                    } else {
                        $('#add-to-cart-success-container').hide();
                    }

                    if (result.errorText) {
                        $('#add-to-cart-error-content').text(result.errorText);
                        $('#add-to-cart-error-container').show();
                    } else {
                        $('#add-to-cart-error-container').hide();
                    }

                    modal.modal('show');
                    updateCartIconQuantity();
                }
                if (!result.success) {
                    console.log('Could not add favorite list to cart');
                }
            }).finally(() => {
                overlay(false);
        });
    });

    /**
     * Delete one favorite item
     */
    $('#favorite-items').on('click', '.remove-favorite-item', function (e) {
        e.preventDefault();
        let url = window.config.urls.favorite.delete;
        let rowId = $(this).closest('.is-cart-item').attr('data-row-id');
        let cartId = $('#favorite-items').attr('data-cart-id');
        url = url.replace(':cart:', cartId).replace(':rowId:', rowId);

        window.axios.delete(url).then(({data: result}) => {
            if (result.success) {
                location.reload();
            }

            if (!result.success) {
                console.log('Could not delete favorite item');
            }
        })
    });

    /**
     * Replace this followUp item from cart (can be within mini-cart, cart page or somewhere else)
     */
    $('#favorite-items').on('click', '.follow-up-favorite', function (e) {
        e.stopPropagation();
        e.preventDefault();
        if ($(this).data('disabled') === true) {
            return;
        }

        $(this).data('disabled', true); // prevent redundant firing of request
        let url = window.config.urls.favorite.followUp;
        const rowId = $(this).data('rowId');
        const cartId = $(this).data('cartId');
        url = url.replace(':cart:', cartId).replace(':rowId:', rowId);
        window.axios.post(url).then(
            function () {
                window.location.reload();
            }
        );
    });

    /**
     * Rename a favorite item
     */
    $('#rename-modal').on('click', '.rename-profile-favorite-list', function (e) {
        e.preventDefault();
        let url = window.config.urls.favorites.rename;
        let id = $(this).attr('data-id');
        let name = $('#input-renameFavoriteModal-' + id + '-name').val();
        window.axios.post(`${url}/${id}`, {name}).then(({data: result}) => {
            if (result.success) {
                location.reload();
            }
            if (!result.success) {
                console.log('Could not rename favorite list');
            }
        })
    });

    $('#favorite-items')
        .on('change', '.cart-item-quantity-change', function (e) {
            let val = parseFloat($(this).val());
            let myCart = cart(e.target);
            $(this).blur();

            setValue(e, val, myCart);
        })
        .on('keyup', '.cart-item-quantity-change', function (e) {
            if (!isFinite(event.key)) {
                return;
            }

            let val = parseFloat($(this).val());

            let max = $(this).data('max');
            let min = $(this).data('min');

            if (val > max) {
                $(this).val(max);
            }

            if (val < min || isNaN(val)) {
                $(this).val(min);
            }

            $(this).trigger('change');
        });
});
